import { useContext } from "react"
import { Button, Text } from "@chakra-ui/react"

import { FlowContext } from "#/shared/context"
import { useWalletTypeFlow } from "#/shared/hooks"

export default function ConnectWalletModalSwitchFlow() {
  const { switchFlow } = useWalletTypeFlow()
  const { isBitcoinFlow } = useContext(FlowContext)

  return (
    <Text color="primary.white.100">
      Don&apos;t have {isBitcoinFlow ? "a Bitcoin" : "an Ethereum"} wallet?{" "}
      <Button
        textDecoration="underline"
        onClick={switchFlow}
        variant="unstyled"
        fontWeight={400}
      >
        Sign in with {isBitcoinFlow ? "Ethereum" : "Bitcoin"} instead
      </Button>
    </Text>
  )
}
